import React from 'react';
import { Link } from 'react-router-dom';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { useI18n } from '../i18n';

const NotFound = () => {
  const { t } = useI18n();

  return (
    <div className="not-found">
      <QuestionMarkCircledIcon className="not-found-icon" />
      <h2>{t('notFound.title')}</h2>
      <p>{t('notFound.body')}</p>
      <Link to="/" className="btn btn-primary not-found-link">
        {t('notFound.home')}
      </Link>
    </div>
  );
};

export default NotFound;
